export default __webpack_public_path__ + "static/media/LBA.fdf2f14b.svg";